module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-transition-group/index.js
// module id = 350
// module chunks = 0